/**
 * Утилиты для работы с токеном авторизации в localStorage
 */

const TOKEN_STORAGE_KEY = 'auth_token';

/**
 * Сохранение токена в localStorage
 */
export const saveToken = (token: string): void => {
  localStorage.setItem(TOKEN_STORAGE_KEY, token);
};

/**
 * Получение токена из localStorage
 */
export const getToken = (): string | null => localStorage.getItem(TOKEN_STORAGE_KEY);

/**
 * Удаление токена из localStorage
 */
export const removeToken = (): void => {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
};

/**
 * Проверка наличия токена
 */
export const hasToken = (): boolean => getToken() !== null;

